import React from 'react';
import { Link } from 'react-router-dom';
import usePointerVars from '../hooks/usePointerVars';
import useMotionPrefs from '../hooks/useMotionPrefs';
import SkillTag from './SkillTag';
import { Pin, Wallet, Clock, ArrowRight } from './icons';

/* ==================================================================
   JobCard
   ------------------------------------------------------------------
   Presentational only - every field comes from data. On hover the
   card lifts, the company mark scales, the skills lift in sequence
   and the apply arrow slides; on a fine pointer the whole card also
   tilts a degree or so toward the cursor.
   ================================================================== */

function initials(name) {
  return name
    .split(/\s+/)
    .slice(0, 2)
    .map((word) => word[0])
    .join('')
    .toUpperCase();
}

export default function JobCard({ job, applyTo, index = 0 }) {
  const { reduced, pointer } = useMotionPrefs();
  const ref = usePointerVars({ disabled: reduced || !pointer });

  return (
    <article ref={ref} className="hs-job" style={{ '--hs-i': index }}>
      <div className="hs-job__top">
        <span className={`hs-job__logo hs-job__logo--${job.companyTone || 'blue'}`}>
          {initials(job.company)}
        </span>
        <span className="hs-job__mode">{job.mode}</span>
      </div>

      <div className="hs-job__id">
        <h3 className="hs-job__role">{job.role}</h3>
        <p className="hs-job__company">{job.company}</p>
      </div>

      <dl className="hs-job__meta">
        <div>
          <dt><Pin /><span className="hs-sr">Location</span></dt>
          <dd>{job.location}</dd>
        </div>
        <div>
          <dt><Wallet /><span className="hs-sr">Stipend</span></dt>
          <dd>{job.stipend}</dd>
        </div>
        <div>
          <dt><Clock /><span className="hs-sr">Duration</span></dt>
          <dd>{job.duration}</dd>
        </div>
      </dl>

      <div className="hs-job__skills">
        {job.skills.map((skill, i) => (
          <SkillTag key={skill} index={i}>{skill}</SkillTag>
        ))}
      </div>

      <Link className="hs-job__apply" to={applyTo}>
        Apply
        <span className="hs-job__apply-arrow"><ArrowRight size={16} /></span>
      </Link>
    </article>
  );
}
